import { Dialog } from '../ui/Dialog';
import { Button } from '../ui/Button';
import type { Tag } from '@/api/client';

interface DeleteTagDialogProps {
    tag: Tag | null;
    open: boolean;
    onClose: () => void;
    onConfirm: (id: number) => Promise<void>;
    isLoading?: boolean;
}

export function DeleteTagDialog({
    tag,
    open,
    onClose,
    onConfirm,
    isLoading = false,
}: DeleteTagDialogProps) {
    const handleConfirm = async () => {
        if (tag) {
            await onConfirm(tag.id);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} title="Delete Tag" size="sm">
            <div className="space-y-4">
                <p className="text-sm text-gray-600 dark:text-gray-400">
                    Are you sure you want to delete the tag{' '}
                    <strong className="font-semibold text-gray-900 dark:text-gray-100">
                        {tag?.label}
                    </strong>
                    ? This action cannot be undone.
                </p>

                <div className="flex justify-end gap-3">
                    <Button variant="secondary" onClick={onClose} disabled={isLoading}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={handleConfirm} isLoading={isLoading}>
                        Delete
                    </Button>
                </div>
            </div>
        </Dialog>
    );
}
